import { createFileRoute } from '@tanstack/react-router';
import {
  campaignsList,
  copilotStatus,
  pipelinePolicy,
  productionsList,
  reportingByProduction,
  venuesList,
} from '@/api/resources';
import { warm, warmBackground } from '@/api/loaders';
import { requireSession } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { PipelineView } from '@/screens/pipeline';

export const Route = createFileRoute('/backend/pipeline')({
  validateSearch: (s: Record<string, unknown>): { focus?: string } => ({
    focus: typeof s.focus === 'string' ? s.focus : undefined,
  }),
  beforeLoad: requireSession,
  // Domain-backed labels, report totals, feature gate and monitor policy warm
  // here. Run/stat/health reads remain poll-driven and mount with the screen.
  loader: ({ context }) => {
    warmBackground(
      context.queryClient,
      campaignsList({}),
      venuesList({}),
      reportingByProduction({}),
      pipelinePolicy(undefined),
      copilotStatus(undefined),
    );
    return warm(context.queryClient, productionsList({}));
  },
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  const { focus } = Route.useSearch();
  return <PipelineView setView={setView} focus={focus} />;
}
